export const columns = function () {
  // 内保单号，机构名称，车牌号，内保起期，内保止期，作废日期，作废类型，标准内保费，折扣，应交内保费（元），净费（元），备注
  return [
    {
      prop: "bh",
      label: "内保单号",
      minWidth: 200,
    },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 100,
    },
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 100,
    },
    {
      prop: "beginTime",
      label: "内保起期",
      minWidth: 200,
    },
    {
      prop: "endTime",
      label: "内保止期",
      minWidth: 200,
    },
    {
      prop: "cancelDate",
      label: "作废日期",
      minWidth: 100,
    },
    {
      prop: "voidType",
      label: "作废类型",
      minWidth: 100,
    },
    {
      prop: "bztcfee",
      label: "标准内保费",
      minWidth: 100,
    },
    {
      prop: "cusRebate",
      label: "折扣",
      minWidth: 100,
    },
    {
      prop: "yjtcfee",
      label: "应交内保费（元）",
      minWidth: 100,
    },
    {
      prop: "netFee",
      label: "净费（元）",
      minWidth: 100,
    },
    {
      prop: "cancelRemark",
      label: "备注",
      minWidth: 100,
    },
  ];
};

export default {};
